module.exports = __webpack_public_path__ + "static/media/p2008bagazh.266362ca.jpg";